import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import TransactionConfirmModal from './TransactionConfirmModal';
import '../stylesheets/ModalOp.css';
import { formatFunction } from '../services/formateFunction';
class TransactionSuccess extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      showDetail: false
    };
  }

  handleClose = () => this.setState({
    showDetail: true
  }, this.props.closeModal());

  showDetail = () => this.setState({
    showDetail: true
  });
  render() {
    // console.log(formatFunction(this.props.result.localModeEventArgs.TotalAmount))
    return (
      this.state.showDetail ?
        <TransactionConfirmModal show={this.state.showDetail} result={this.props.result.customerReceipt} buttonText={this.props.buttonText} closeModal={this.handleClose} />
        :
        <Modal show={this.props.show} backdrop="static" dialogClassName={this.props.isMobile ? null : 'fit-content'} onHide={this.handleClose} animation={false}>
          <Modal.Body className="transaction-success-body">
            <img
              alt=""
              id="success"
              src={`${process.env.PUBLIC_URL}/assets/images/approved.png`} />
            <h5>{this.props.buttonText.Approved}<br />{this.props.buttonText.Amount} = {formatFunction(this.props.result.localModeEventArgs.TotalAmount)}</h5>
          </Modal.Body>
          <Modal.Footer className="justify-button-space">
            <Button variant="secondary" id="closeTransactionDialogue" onClick={this.handleClose}>
              {this.props.buttonText.Close}
            </Button>
            <Button variant="primary" id="showDetail" onClick={this.showDetail}>
              {this.props.buttonText.Details}
            </Button>
          </Modal.Footer>
        </Modal>
    );
  }
}
export default TransactionSuccess;